// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ck-content blockquote{\n  overflow:hidden;\n  font-style:italic\n}[dir=ltr] .ck-content blockquote{\n  padding-right:1.5em;\n  padding-left:1.5em;\n  margin-left:0;\n  margin-right:0;\n  border-left:5px solid #ccc\n}[dir=rtl] .ck-content blockquote{\n  padding-left:1.5em;\n  padding-right:1.5em;\n  margin-right:0;\n  margin-left:0;\n  border-right:5px solid #ccc\n}\n\n.ck-content[dir=rtl] blockquote{\n  border-left:0;\n  border-right:5px solid #ccc\n}", ""]);
// Exports
module.exports = exports;
